import { isMobile } from "react-device-detect";

export const styles = {
    drawerBody: {
        background: '#edf3ff',
        padding: 0,
    },
    pageWrap: {
        padding: isMobile ? 14 : 20,
        background: '#edf3ff',
        minHeight: '100%',
    },
    topCard: {
        background: '#fff',
        border: '1px solid #eef2f7',
        borderRadius: 18,
        padding: isMobile ? 16 : 20,
        marginBottom: 16,
    },
    customerBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '14px 16px',
        borderRadius: 14,
        background: 'linear-gradient(135deg, rgba(22,119,255,0.08) 0%, rgba(24,144,255,0.03) 100%)',
        border: '1px solid #d6e4ff',
    },
    customerIcon: {
        width: 42,
        height: 42,
        borderRadius: 12,
        background: '#e6f4ff',
        color: '#1677ff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 18,
        flexShrink: 0,
    },
    customerTitle: {
        fontSize: 12,
        color: '#6b7280',
        marginBottom: 4,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
    },
    customerName: {
        fontSize: isMobile ? 16 : 18,
        fontWeight: 700,
        color: '#1f2937',
        lineHeight: 1.35,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1f2937',
        marginBottom: 4,
    },
    sectionDesc: {
        fontSize: 13,
        color: '#6b7280',
        marginBottom: 16,
        lineHeight: 1.6,
    },
    formItemTight: {
        marginBottom: 14,
    },
    helperCard: {
        marginBottom: 16,
        padding: '14px 16px',
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 14,
    },
    helperTitle: {
        fontWeight: 700,
        color: '#1677ff',
        marginBottom: 4,
    },
    helperText: {
        fontSize: 14,
        color: '#4b5563',
        lineHeight: 1.6,
    },
    totalCard: {
        marginTop: 12,
        marginBottom: 16,
        padding: isMobile ? '16px' : '18px 20px',
        background: 'linear-gradient(135deg, #f6fbff 0%, #edf6ff 100%)',
        border: '1px solid #cfe3ff',
        borderRadius: 16
    },
    totalLabel: {
        fontSize: 12,
        fontWeight: 700,
        color: '#6b7280',
        marginBottom: 6,
        textTransform: 'uppercase',
        letterSpacing: 0.4,
    },
    totalValue: {
        fontSize: isMobile ? 26 : 30,
        fontWeight: 800,
        color: '#1677ff',
        lineHeight: 1.2,
    },
    actionBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        flexWrap: 'wrap',
        background: '#fff',
        border: '1px solid #eef2f7',
        borderRadius: 14,
        padding: '12px 14px',
        marginBottom: 14
    },
    collapseWrap: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    panelHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        flexWrap: 'wrap',
        paddingRight: 8,
    },
    panelHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        minWidth: 0,
        flex: 1,
    },
    panelIndex: {
        width: 38,
        height: 38,
        borderRadius: 999,
        background: 'linear-gradient(180deg, #5b8cff 0%, #3f74f7 100%)',
        color: '#fff',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        fontSize: 18,
        boxShadow: '0 6px 14px rgba(63, 116, 247, 0.18)',
    },
    panelTitleWrap: {
        minWidth: 0,
    },
    panelTitle: {
        fontWeight: 700,
        color: '#172033',
        fontSize: 17,
        lineHeight: 1.45,
    },
    panelSubTitle: {
        fontSize: 13,
        color: '#6b7280',
        marginTop: 4,
    },
    progressTag: {
        fontSize: 12,
        color: '#2f5fe3',
        background: '#eef4ff',
        border: '1px solid #d9e5ff',
        borderRadius: 999,
        padding: '7px 14px',
        fontWeight: 700,
        whiteSpace: 'nowrap',
        marginRight: 20,
        boxShadow: '0 4px 10px rgba(63, 116, 247, 0.08)',
    },
    panelBody: {
        padding: isMobile ? 14 : 18,
    },
    blockCard: {
        background: '#fff',
        border: '1px solid #eef2f7',
        borderRadius: 16,
        padding: 16,
        marginBottom: 16,
    },
    blockTitle: {
        fontSize: 16,
        fontWeight: 700,
        color: '#1f2937',
        marginBottom: 12,
    },
    noteArea: {
        borderRadius: 12,
    },
    deleteWrap: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 12,
    },
    modalCard: {
        background: '#f8fafc',
        border: '1px solid #eef2f7',
        borderRadius: 14,
        padding: 16,
    },
}